import api from 'dashboard/resources/site-operational-status.api';
import actionTypes from './action-types';

export const fetchSiteOperationalStatusRequest = () => ({
  type: actionTypes.FETCH_SITE_OPERATIONAL_STATUS_REQUEST,
  name: 'siteOperationalStatusLoadingStatus',
});

export const fetchSiteOperationalStatusSuccess = (retailers, pagination) => ({
  type: actionTypes.FETCH_SITE_OPERATIONAL_STATUS_SUCCESS,
  name: 'siteOperationalStatusLoadingStatus',
  retailers,
  pagination,
});

export const fetchSiteOperationalStatusFailure = () => ({
  type: actionTypes.FETCH_SITE_OPERATIONAL_STATUS_FAILURE,
  name: 'siteOperationalStatusLoadingStatus',
});

export const fetchSiteOperationalStatus = (requestParams) => async (dispatch) => {
  try {
    dispatch(fetchSiteOperationalStatusRequest());
    const {
      content: retailers,
      ...pagination
    } = await api.fetchSiteOperationalStatus(requestParams);

    dispatch(fetchSiteOperationalStatusSuccess(retailers, pagination));
  } catch (error) {
    console.error('FETCH_SITE_OPERATIONAL_STATUS', error);
    dispatch(fetchSiteOperationalStatusFailure());
  }
};



// WEBPACK FOOTER //
// ./src/modules/dashboard/actions/site-operational-status/site-operational-status.actions.js